/* eslint-disable no-unused-vars */
export enum StyleConstants {
  NAV_BAR_HEIGHT = '4rem',
  INSTALL_HEADER_HEIGHT = '3rem',
}
